import { Injectable } from '@angular/core';
import { AnalyticsSiteAssets } from '@com-delta-idp/mnx-skymiles-landing-page-ui';
import { Summary } from '@com-delta-idp/mnx-skymiles-shared';
import { DATA_ANALYTICS } from '../../models';

@Injectable({ providedIn: 'root' })
export class DataLayerAssetsHelperService {
  setStatusAssets(assets: AnalyticsSiteAssets[], summary: Summary): void {
    assets.push({
      id: summary.title.replace(/\s+/g, '').toLowerCase(),
      type: DATA_ANALYTICS.TILES,
      name: summary.title,
      miles: +summary.value.replace(/,/g, ''),
      sub_type: DATA_ANALYTICS.AWARD,
      image_url: this.isMillionMiler(summary.level)
        ? `/content/dam/delta-applications/ui-kit/assets/svg/skymiles/tracker/million-miler/tracker-million-miler-${summary.level}.svg`
        : '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/moments/globe.svg',
      source: DATA_ANALYTICS.SOURCE,
      category: this.isMillionMiler(summary.level)
        ? `millionmiler:${summary.level}`
        : 'other'
    });
  }

  setSummaryAssets(assets: AnalyticsSiteAssets[], summary: Summary): void {
    assets.push({
      id: summary.title.replace(/\s+/g, '').toLowerCase(),
      type: DATA_ANALYTICS.TILES,
      name: DATA_ANALYTICS.MILES_AVAILABLE,
      sub_type: DATA_ANALYTICS.AWARD,
      miles: +summary.value.replace(/,/g, ''),
      source: DATA_ANALYTICS.SOURCE
    });
  }

  isMillionMiler(level: string) {
    return !(+level > 20 || +level === 0);
  }
}
